import service from '@/utils/request'
import store, { baseAPI, baseUrl } from '../store'

const constApi = baseAPI + baseUrl + 'constant/desc/list'

const constName = {
  // 通用奖品事件码
  eventCode: 'com.quhong.enums.EventCode',
  // 通用奖品奖励类型
  awardType: 'com.quhong.enums.RewardItemType',
  // 活动使用时区
  timeZone: 'com.quhong.constant.activity.model.event.mode.ZoneOffsetConstant',
  // 活动格式化日期格式
  dateFormat: 'com.quhong.constant.activity.model.event.mode.DateFormatPatternConstant',
  // 参与群体
  joinMode: 'com.quhong.constant.activity.model.join.mode.JoinModeConstant',
  // 榜单类型
  activityRankType: 'com.quhong.core.annotation.ActivityRankType',
  // 活动方式
  eventMode: 'com.quhong.constant.activity.model.event.mode.EventModeConstant',
  // 条件方式
  conditionMode: 'com.quhong.constant.activity.model.join.mode.ConditionModeConstant',
  // 条件符号
  condition: 'com.quhong.constant.activity.model.join.mode.ConditionConstant',
  // 链接方式
  relation: 'com.quhong.constant.activity.model.join.mode.RelationConstant',
  // 通话类型
  fromType: 'com.quhong.core.enums.CallFromType',
  // 拒绝原因
  refuseReason: 'com.quhong.constant.chat.ChatEndReasonConstant',
  // 任务类型
  taskType: 'com.quhong.constant.activity.model.event.mode.TaskTypeConstant',
  // 任务方式
  taskMode: 'com.quhong.constant.activity.model.event.mode.TaskModeConstant',
  // 任务周期
  taskDuration: 'com.quhong.constant.activity.unit.EventUnitTaskDuration',
  // 游戏类型
  gameType: 'com.quhong.core.constant.game.GameTypeConstant',
  // 游戏登录类型
  gameLoginType: 'com.quhong.core.constant.game.GameLoginTypeConstant',
  // 榜单周期类型
  rankCycleType: 'com.quhong.enums.RankCycleType',
  // 幸运礼物子奖池类型
  luckyGiftSonPool: 'com.quhong.constant.activity.luckyGift.LuckyGiftSonPoolConstant',
  // 幸运礼物标签
  luckyGiftLabel: 'com.quhong.constant.activity.luckyGift.LuckyGiftLabelConstant',
  // 通用运营用户群体
  userGroup: 'com.quhong.constant.general.operating.GeneralOperatingUserGroupConstant',
  // 表情包类型
  emojiType: 'com.quhong.constant.EmojiTypeConstant',
  // 邀请抽奖奖励类型
  inviteLotteryRewardType: 'com.quhong.constant.InviteLotteryRewardConstant',
  // 邀请抽奖券类型
  inviteLotteryTicketPriceType: 'com.quhong.constant.InviteLotteryTicketPriceConstant',
}

export const getConstList = async (type) => {
  const { data: res } = await service({
    method: 'get',
    url: constApi,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      className: constName[type]
    }
  })
  return res
}
